import template from './subscriptions.html';
import './subscriptions.styl';

function subscriptionsComponent(AuthService) {

  'ngInject';

  this.companyId = AuthService.getCompanyId();
}

export default {
  template,
  controller: subscriptionsComponent,
};



// WEBPACK FOOTER //
// ./src/containers/subscriptions/index.js